import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { MemberComponent } from "./Member";
import { Header } from "./styles";
import { TeamsComponent } from "./Team";
import { useAppState } from "Context/StateContext";
import { checkResourceCan, FN_NAMES, hasPermission, isShowAction } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";

export interface MemberTabsProps {
  currentActive: "members" | "teams";
  setCurrentActive: (active: "members" | "teams") => void;
}

export const MemberTabs = (props: MemberTabsProps) => {
  const { t: translate } = useTranslation();

  const { currentActive, setCurrentActive } = props;
  const {currentUser, userPermissions} = useAppState();
  const [teamPermission, setTeamPermission] = useState<{
    view: boolean,
  }>({
    view: false,
  });

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setTeamPermission({
        view: hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_TEAMS_VIEW),
      })
    }
  }, [userPermissions])

  return (
    <Header.Root>
      {
        isShowAction(currentUser, teamPermission.view)
          ? (
            <>
              <Header.Button
                active={currentActive === "members"}
                onClick={() => setCurrentActive("members")}
              >
                <Header.Text active={currentActive === "members"}>{translate("members")}</Header.Text>
              </Header.Button>
              <Header.Button
                rightButton
                active={currentActive === "teams"}
                onClick={() => setCurrentActive("teams")}
              >
                <Header.Text active={currentActive === "teams"}>{translate("teams")}</Header.Text>
              </Header.Button>
            </>
          )
          : null
      }
    </Header.Root>
  );
};

export function MembersComponent() {
  const [currentActive, setCurrentActive] = useState<MemberTabsProps["currentActive"]>("members");
  const {currentUser, userPermissions} = useAppState();
  const [memberPermission, setMemberPermission] = useState<{
    member: {
      edit: boolean,
      create: boolean,
      resendWelcomeEmail: boolean,
    },
    team: {
      edit: boolean,
      create: boolean,
    }
  }>({
    member: {
      edit: false,
      create: false,
      resendWelcomeEmail: false,
    },
    team: {
      edit: false,
      create: false,
    }
  });

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setMemberPermission({
        member: {
          edit: checkResourceCan(userPermissions, ResourceName.PEOPLE, ResourceCanEnum.EDIT) && hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_MEMBERS_EDIT),
          create: checkResourceCan(userPermissions, ResourceName.PEOPLE, ResourceCanEnum.EDIT) && hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_MEMBERS_ADD_NEW),
          resendWelcomeEmail: hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_MEMBERS_RESEND_WELCOME_EMAIL),
        },
        team: {
          edit: checkResourceCan(userPermissions, ResourceName.PEOPLE, ResourceCanEnum.EDIT) && hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_TEAMS_EDIT),
          create: checkResourceCan(userPermissions, ResourceName.PEOPLE, ResourceCanEnum.EDIT) && hasPermission(userPermissions, FN_NAMES.FUNCTION_SETTINGS_PEOPLE_TEAMS_ADD_NEW),
        }
      })
    }
  }, [userPermissions])

  return (
    <div>
      <MemberTabs currentActive={currentActive} setCurrentActive={setCurrentActive} />

      {currentActive === "members" ? <MemberComponent permission={{
        edit: isShowAction(currentUser, memberPermission.member.edit),
        create: isShowAction(currentUser, memberPermission.member.create),
        resendWelcomeEmail: isShowAction(currentUser, memberPermission.member.resendWelcomeEmail),
      }} /> : <TeamsComponent permission={{
        edit: isShowAction(currentUser, memberPermission.team.edit),
        create: isShowAction(currentUser, memberPermission.team.create),
      }} />}
    </div>
  );
}
